import React, { FunctionComponent, MouseEventHandler } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import { DialogActions } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CardTitle from 'containers/common/Card/CardTitle';
import styled from 'styled-components';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';

const DialogTitle = (props: any) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    width: '100%',
    height: '100%',
  },
}))(MuiDialogContent);
const DialogTitleStyled = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))(DialogTitle);
const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    min-width: 900px;
  }
  .MuiDialogActions-root {
    flex: 0 0 auto;
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
  }
`;
const DialogCivilProceeding: FunctionComponent<{
  open: boolean;
  handleClose: MouseEventHandler;
  title: string;
  children: any;
  confirmTitle: string;
  cancelTitle: string;
  disablePrimaryButton?: boolean;
  handleValidate: MouseEventHandler;
}> = (props): JSX.Element => {
  return (
    <div>
      <StyledDialog
        onClose={() => props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitleStyled onClose={props.handleClose}>
          <div className="header">
            <CardTitle count={-1} message={props.title} />
          </div>
        </DialogTitleStyled>
        <DialogContent dividers>{props.children}</DialogContent>
        <DialogActions>
          <SecondaryButton
            title={props.cancelTitle}
            onClick={props.handleClose}
          />
          <PrimaryButton
            background={'#0075C9'}
            titlecolor={'#FFFFFF'}
            border={'#0075C9'}
            title={props.confirmTitle}
            onClick={props.handleValidate}
            disabled={props.disablePrimaryButton || false}
          />
        </DialogActions>
      </StyledDialog>
    </div>
  );
};
export default DialogCivilProceeding;
